<template>
  <div
    v-bind="
      $ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'internalName'
      })
    "
  >
    <LibRichTextRendererDiv
      v-if="item.fields.content"
      :rich-text="item.fields.content"
      :cols="mapColsWidth(item.fields.tableWidth) ?? 8"
      :cols-centered="item.fields?.colsCentered ?? true"
      :content-centered="item.fields?.contentCentered ?? false"
      :initial-visible-rows="item.fields?.initialVisibleRows"
      :show-more-text="item.fields?.showMoreText"
      :highlighted-columns="item.fields?.highlightedColumns"
    />
  </div>
</template>

<script setup lang="ts">
import type { IFeaturesTable } from '~~/lib/ContentfulService';
import { mapColsWidth } from '~/utils/mapColsWidth';
const { $ContentfulLivePreview } = useNuxtApp();

interface Props {
  item: IFeaturesTable;
}

defineProps<Props>();
</script>
